module.exports = __webpack_public_path__ + "static/media/status-expired.c07d3802.svg";